import React,{useEffect,useState} from "react";
import { Route ,useHistory } from "react-router-dom";
import { connect } from "react-redux";
import SuperAdminRoute from "./SuperAdminRoute";
import OrganizationRoute from "./OrganizationRoute";
import UserRoute from "./UserRoute";
import LeadManagerRoute from "./LeadManagerRoute";
import DrilldownDataRoute from "./DrilldownDataRoute";
import OrganizationManagerRoute from "./OrganizationManagerRoute";
import { firestore, functions } from "../Firebase";
import { getDateString,getDateIsoString,compareDates,getExpirationDate,sendMail,getDateString2, extractQueryParams, deviceCheck } from "../Values/utils";
import { setDeactivationAlert,setOrganizationData,setAuthToken, setAnalyticsFilterObject, setCallRecordingStatus, setShowMMBBucket, setWAAgentActiveStatus, setHasActiveWAPackage, setAccessMAStatus } from "../Redux/actions";
import { useDispatch } from "react-redux";
import {handleUser,handlePaymentStatus,handlePaymentStatus1} from "../Services/auth";
import { setMBStaticConstants, updateUserPreference } from "../Services/resources";
import { auth } from "../Firebase";
import LogOutModal from "../Components/Modals/LogOutModal/LogOutModal";
import { url } from "../Values/constants";
import axios from 'axios';
import axiosHandler from "../Services/axiosHandler";
import {fetchOrgResMongo} from "../Services/resources"
import { fetchOrganizationData, orgHadCallRecordingSubscription, showMMBBucket } from "../Services/organizations";
import ForceMobileUpdateModal from "../Components/Modals/ForceMobileUpdateModal/ForceMobileUpdateModal";
import ContactDetails from "../Screens/ContactDetails/ContactDetails";
import moment from "moment";
import {fetchSingleMBData} from "../Services/contacts";
import { canAccessMarketingAutomationModule, hasActiveWAPackage,isWAAgentActive } from "../Services/marketingAutomation";
import WhyReadPro from "../Components/WhyReadPro/WhyReadPro";
import { showPopupOnPageLoad } from "../Values/utils";
import AgentReverseFeedbackSlides from "../Screens/AgentReverseFeedback/AgentReverseFeedbackSlides";
import CenteredPopUp from "../Components/CenteredPopUp/CenteredPopUp";
import AgentReverseFeedbackThakyou from "../Screens/AgentReverseFeedback/AgentReverseFeedbackThakyou";
import BroadcastSlides from "../Screens/BroadcastSlides/BroadcastSlides";
import { fetchShowReportTab } from "../Services/reports";
import FreeTrialMarketingPopupContent from "../Screens/FreeTrials/FreeTrialMarketingPopupContent";
import style from "../Screens/FreeTrials/FreeTrialMarketingPopupContent.module.css"
import Loading from "../Components/Loading/Loading";
import styles from "../Screens/MarketingPanel/MarketingScreen.module.css";
import FreeTrialWhatappComponentV2 from "../Screens/FreeTrials/FreeTrialWhatappComponentV2";
import FreeTrialWhatappComponentV1 from "../Screens/FreeTrials/FreeTrialWhatappComponentV1";
import FreeTrialWhatsappModal from "../Screens/FreeTrials/FreeTrialWhatsappModal";
import HtmlBanner from "../bannerManagement/baneerComp"
import FooterPopUp from "../Components/FooterPopUp/FooterPopUp";
import { readproPackagePurchaseViaPGI } from "../Services/pgi";
import AimcModal from "../Components/Modals/AimcModal/AimcModal";
const HomeRoute = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  let path = props.history.location.pathname;
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [usersEmail, setUsersEmail] = useState<any[]>([]);
  const [openMobileUpdateModal, setOpenMobileUpdateModal] = useState(false);
  const [showWhyReadPro, setShowWhyReadPro] = useState(false);
  const [showAgentReverseFeedbackSlide, setShowAgentReverseFeedbackSlide] = useState(false);
  const [showWhatsappSlides, setShowWhatsappSlides] = useState(false);
  const [showAimcPopup, setShowAimcPopup] = useState(false);
  // const [showFreeTrialWhatappComponentV1, setShowFreeTrialWhatappComponentV1] = useState(false);
  // const [showFreeTrialWhatappComponentV2, setShowFreeTrialWhatappComponentV2] = useState(false);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
    const [showFreeTrialWhatappComponentV1, setShowFreeTrialWhatappComponentV1] = useState(false);
    const [showFreeTrialWhatappComponentV2, setShowFreeTrialWhatappComponentV2] = useState(false);
    const isInWebView:any = window.ReactNativeWebView;
    const [showGenericPopupContent, setShowGenericPopupContent] = useState(true)
   const [cRoute,setCRoute]=useState("")
   const [showFooterPopup, setShowFooterPopup] = useState(true)
     const [show,setShow] = useState(true);

   useEffect(()=>{
     setCRoute(props.currentRoute)
   },[props.currentRoute])
 

  useEffect(()=>{
    if(props.user.user_email && props.isUsingApp !== null && props.hasActiveWAPackage !== null && !isInWebView ){
      showPopupOnPageLoad(props.user,setShowWhyReadPro,props.organization,setShowAgentReverseFeedbackSlide,props.isUsingApp,props.hasActiveWAPackage,setShowWhatsappSlides,setShowFreeTrialWhatappComponentV2,setShowFreeTrialWhatappComponentV1,setShowFreeTrialModal, props.organization.WhatsAppTrialPack, setShowAimcPopup, props.organization.AiMagicConnectTrial);
    }
  },[props.user.user_email,props.isUsingApp,props.organization.show_consent,props.organization.show_feedback_popup,props.organization.lead_reverse_feedback,props.hasActiveWAPackage, props.organization.AiMagicConnectTrial])

  // const [contId,setContId]=useState(cookie.get())

  const handleIsWAAgentActive = async (organizationId:string) => {
    let agentStatus = await isWAAgentActive(organizationId,()=>{},()=>{});
    dispatch(setWAAgentActiveStatus({ WAAgentActiveStatus: agentStatus }));
  }
  
  const handleHasActiveWAPackage = async (soid: string) => {
    let waStatus = await hasActiveWAPackage(soid);
    dispatch(setHasActiveWAPackage({ hasActiveWAPackage: waStatus }));
  }

  useEffect(() => {
    if (path !== "/marketing") {
      // console.log("ahaha",path)
      window.scrollTo(0, 0);
      document.body.classList.remove('no-overflow');
    }
  }, [path])

  useEffect(() => {
    const fetchData = async () => {
      // const contact_id = localStorage.getItem("contact_id");

      // console.log("VFCD","I rannnn1 1111")
      const contactId=localStorage.getItem("contact_id")
      
      if (props.contact_id || contactId) {

        try {
          // Assuming fetchSingleMBData is an async function that fetches data
          const data = await fetchSingleMBData((props.contact_id || contactId));
          // console.log("contact_details data",data)
          // Navigate to /contactDetails and pass contact_id in state
          localStorage.removeItem("contact_id")
          const formatDate = (date:any) => {
            return date ? moment(date).format('DD MMM YY, LT') : '';
          };
          history.replace({
            pathname: "/contactDetails",
            state: { detail:{  ...data,
              created_at: formatDate(data['created_at']),
              lead_assign_time: formatDate(data['lead_assign_time']),
              next_follow_up_date_time: formatDate(data['next_follow_up_date_time']),
              modified_at: formatDate(data['modified_at']),
              stage_change_at: formatDate(data['stage_change_at']),
              feedback_time: formatDate(data['feedback_time']),
              due_date: formatDate(data['due_date']),
              contactId:data['Id']
            } } // You can also pass the fetched data if needed
          });
        } catch (error) {
          console.error("Error fetching contact data", error);
          history.replace("/contacts")
        }
      }
    };

    fetchData(); // Call the async function
  }, [props.contact_id,props.userId]);

  useEffect(()=>{
    if (props?.user?.organization_id) {
      let organizationId = props.user.organization_id;
      let uid = props.user.uid;
      let oid = props.user.user_oid;
      showMMBBucket(organizationId, uid).then(async (data) => {
        dispatch(setShowMMBBucket({ showMigratedBucket: data }));
      });
      handleIsWAAgentActive(organizationId);
      handleHasActiveWAPackage(oid);
    }
  },[props.user.organization_id])

  useEffect(() => {
    let organizationId = props.user.organization_id;

    if(props.user.organization_id){
      fetchOrganizationData(organizationId).then(async (data) => {
        let is_call_recording_enabled = data.is_call_recording_enabled ? data.is_call_recording_enabled : false;
        let is_call_recording_subscribed = data.is_call_recording_subscribed ? data.is_call_recording_subscribed : false;
        let organizationHadCallRecordingSubscription = false;
        let show_call_recording_enable_option = false;
        organizationHadCallRecordingSubscription  = await orgHadCallRecordingSubscription(organizationId);
        if(is_call_recording_subscribed && (props.user.profile === "Lead Manager" || props.user.profile === "Admin")){
          show_call_recording_enable_option = true;
        }else if(is_call_recording_subscribed == false && (props.user.profile === "Lead Manager" || props.user.profile === "Admin") && organizationHadCallRecordingSubscription){
          show_call_recording_enable_option = true;
        }
        dispatch(setOrganizationData({ organizationData: data }));
        dispatch(setCallRecordingStatus({ is_call_recording_enabled,is_call_recording_subscribed,show_call_recording_enable_option }));
      });
    }
  }, [props.user.organization_id]);

  useEffect(() => {
    let unSub:any;

    const handleEffect = async () => {
      if (props.user.uid) {
        // unSub = await handlePaymentStatus1(props.user.organization_id, props.user, dispatch);
        updateUserPreference(props.authToken, dispatch,props.user.uid,props.user.organization_id);
      }
    };

    handleEffect();

    if(props.user.user_super_oid && props.organization.lead_reverse_feedback === "Y"){
      fetchShowReportTab(props.user.user_super_oid,dispatch)
    }

    return () => {
      if (unSub) {
        unSub(); // Ensure unSub is called during cleanup
      }
    };
  }, [
    props.user.uid, props.organization
  ]);

    function option(a: { label: any } | string, b: { label: any } | string): number {
    if (typeof a === 'string' && typeof b === 'string') {
      // Handle the case where both a and b are strings
      if (a > b) return 1;
      if (a < b) return -1;
      return 0;
      
      return 0;
    } else if (typeof a === 'object' && typeof b === 'object') {
      // Handle the case where both a and b are objects with a 'label' property
      if (a.label > b.label) return 1;
      if (a.label < b.label) return -1;
    
      return 0;
    } else {
      return 0; 
    }
  }

  const getContactsFilter = async () => {
      let organizationUsersArray: any[] = [];
      const users: { [key: string]: string } = {};

      props.organizationUsers.map((user: any) => {
        users[user.uid] = user.user_first_name + ' ' + user.user_last_name;
        organizationUsersArray.push(user.user_email);
      });

    let finalFilter: { [key: string]: any } = {};
    // axios.defaults.headers.common['x-access-token'] = props.authToken
    const res = await axiosHandler.post(url + '/leads/filterValues', {
      // uid: props.user.uid,
    });
    let l: any[] = [];
    if (res.data[0]) {
      l = Object.keys(res.data[0]);
      finalFilter = res.data[0];
    }
    // axios.defaults.headers.common['x-access-token'] = props.authToken
    const taskRes = await axiosHandler.post(url + '/tasks/filterValues', {
      // uid: props.user.uid,
    });

    let tasks: { [key: string]: [] } = {};
    if (taskRes.data[0]) {
      Object.keys(taskRes.data[0]).forEach((key) => {
        if (!l.includes(key)) {
          tasks[key] = taskRes.data[0][key];
          l.push(key);
        }
      });
    }

    // axios.defaults.headers.common['x-access-token'] = props.authToken
    const callRes = await axiosHandler.post(url + '/callLogs/filterValues', {
      uid: props.user.uid,
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: props.user.organization_id,
      uid: props.user.uid,
      });
    let calls: { [key: string]: [] } = {};
    if (callRes.data[0]) {
      Object.keys(callRes.data[0]).forEach((key) => {
        if (!l.includes(key)) {
          calls[key] = callRes.data[0][key];
          l.push(key);
        }
      });
    }
    let otherFilters = {
      transfer_status:["True","False"],
      lead_type:['Data','Leads'],
      reporting_to: organizationUsersArray,
      previous_owner_1: organizationUsersArray,
      previous_owner_2: organizationUsersArray,
      transfer_by_1: organizationUsersArray,
      transfer_by_2: organizationUsersArray,
      previous_stage_1: [
        'FRESH',
        'INTERESTED',
        'LOST',
        'WON',
        'NOT INTERESTED',
        'CALL BACK',
      ],
      previous_stage_2: [
        'FRESH',
        'INTERESTED',
        'LOST',
        'WON',
        'NOT INTERESTED',
        'CALL BACK',
      ],
      status: ['Completed', 'Pending', 'Overdue'],
      employee_name:userdetail.data.data.Employee_Name,
      employee_id:userdetail.data.data.Employee_id
    };

    finalFilter = { ...finalFilter, ...tasks, ...calls, ...otherFilters };

    Object.keys(finalFilter).forEach((val:any)=>{

      if(val==="employee_id" || val==="employee_name"){
        finalFilter[val]=finalFilter[val].sort(option);
      }
      else{
        finalFilter[val]=finalFilter[val].sort();
      }
  })
  dispatch(setAnalyticsFilterObject(finalFilter));
    // setFilterValue(finalFilter);
  };

  useEffect(() => {
    if (props.user.uid && props.organizationUsers) {
      getContactsFilter();
    }
  }, [props.user.uid, props.organizationUsers]);
  useEffect(()=>{
      if(props.user.uid){
        fetchOrgResMongo(props.user.organization_id,dispatch)
      }
  },[props.user])

  useEffect(() => {
    const setAccessMarketingAutomationModule = async () => {
      let access = await canAccessMarketingAutomationModule(props.user.organization_id);
      dispatch(setAccessMAStatus({ accessAllowedMarketingAutomation: access }));
    };

    if (props.user.organization_id) {
      setAccessMarketingAutomationModule();
    }
    setMBStaticConstants(dispatch)
  }, [
    props.user.organization_id
  ]);
  const [showThankYou, setShowThankYou] = useState(false);
//   console.log("showFreeTrialWhatappComponentV1 HOME",showFreeTrialWhatappComponentV1)
// console.log("showFreeTrialWhatappComponentV2 HOME",showFreeTrialWhatappComponentV2)
// console.log("showWhatsappSlides HOME",showGenericPopupContent)
  return (
    <div>
      {(props.initialParams["packageId"] && props.user.profile === "Admin") && <Loading fullScreen />  }
      <LogOutModal
        openModal={openLogoutModal}
        setOpenLogoutModal={setOpenLogoutModal}
      />
      {/* <ForceMobileUpdateModal
        open={openMobileUpdateModal}
        close={() => setOpenMobileUpdateModal(false)}
      /> */}
      {show && (
        <>
          {showAgentReverseFeedbackSlide && (
            <AgentReverseFeedbackSlides
              setShowAgentReverseFeedbackSlide={setShowAgentReverseFeedbackSlide}
              setShowThankYou={setShowThankYou}
            />
          )}

          {showThankYou && (
            <CenteredPopUp
              setModal={setShowThankYou}
              modiferClass={"AgentReverseFeedbackThanks"}
              closeIcon={true}
            >
              <AgentReverseFeedbackThakyou setShowThankYou={setShowThankYou} />
            </CenteredPopUp>
          )}

          {showWhyReadPro && <WhyReadPro setShowWhyReadPro={setShowWhyReadPro} />}

          {/* <AimcModal user={props.user} dispatcher={dispatch}/> */}
          {showAimcPopup && <AimcModal user={props.user} dispatcher={dispatch}/>}

          {showWhatsappSlides && (
            <CenteredPopUp
              setModal={setShowWhatsappSlides}
              modiferClass={style.FtmktPopup}
              closeIcon={true}
              popupName="Whatsapp_Marketing"
            >
              <FreeTrialMarketingPopupContent />
            </CenteredPopUp>
          )}

          {showFreeTrialModal && (
            <CenteredPopUp
              setModal={setShowFreeTrialModal}
              modiferClass={styles.ftmModal}
              closeIcon={true}
              closeClassMofifier={styles.ftmClose}
            >
              <FreeTrialWhatsappModal closePopup={setShowFreeTrialModal} />
            </CenteredPopUp>
          )}
        </>
      )}


    {
        cRoute && showFooterPopup && (
          <FooterPopUp
              setModal={setShowFooterPopup}
              children={<HtmlBanner  user={props.user} setShowGenericPopupContent={setShowFooterPopup} route={cRoute} bannerType={"footerPopup"}/>}
              modiferClass={style.FtmktPopup}
              closeIcon={true}
              popupName="footer_banner"
            />
        )
      }

{
        cRoute && showGenericPopupContent && (
          <CenteredPopUp
              setModal={setShowGenericPopupContent}
              children={<HtmlBanner  user={props.user} setShowGenericPopupContent={setShowGenericPopupContent} route={cRoute} bannerType={"popup"} setShow={setShow} />}
              modiferClass={styles.GenPopCont}
              closeIcon={true}
              popupName="genericPopup"
            />
        )
      }
      {/* {
        showFreeTrialWhatappComponentV2 && (
          <CenteredPopUp
          setModal={setShowFreeTrialWhatappComponentV2}
          children={<FreeTrialWhatappComponentV2 closePopup={setShowFreeTrialWhatappComponentV2}/>}
          modiferClass={styles.FtmktPopupv2}
          closeIcon={true}
          closeClassMofifier={styles.FtmktPopupClosev2}
        />
        )
      }
      {
        showFreeTrialWhatappComponentV1 && (
          <CenteredPopUp
          setModal={setShowFreeTrialWhatappComponentV1}
          children={<FreeTrialWhatappComponentV1 closePopup={setShowFreeTrialWhatappComponentV1}/>}
          modiferClass={styles.FtmktPopupv1}
          closeIcon={true}
          closeClassMofifier={styles.FtmktPopupClosev1}
        />
        )
      } */}
      {String(props.history.location.pathname).startsWith("/resetpassword") !==
        true &&
        props.userStatus && (
          <>
            {props.userStatus === true && (
              <>
                {String(props.history.location.pathname).startsWith(
                  "/drilldownData"
              ) !== true &&
                  String(props.history.location.pathname).startsWith(
                    "/taskDrilldownData"
                  ) !== true &&
                  String(props.history.location.pathname).startsWith(
                    "/callDrilldownData"
                  ) !== true && (
                    <>
                    
                      {props.userRole === "superAdmin" && (
                        <Route component={SuperAdminRoute} />
                      )}
                      {props.userRole === "Operation Manager" && (
                        <Route component={OrganizationManagerRoute} />
                      )}
                      {props.userRole === "organization" && (
                        <Route component={OrganizationRoute} />
                      )}
                      {props.userRole !== "organization" &&
                        props.userRole !== "superAdmin" &&
                        props.userRole !== "Lead Manager" &&
                        props.userRole !== "Operation Manager" &&(
                          <Route component={UserRoute} />
                        )}
                      {props.userRole === "Lead Manager" && (
                        <Route component={LeadManagerRoute} />
                      )}
                    </>
                  )}

                {String(props.history.location.pathname).startsWith(
                  "/drilldownData"
                ) === true && (
                  <Route path="/drilldownData" component={DrilldownDataRoute} />
                )}
                {String(props.history.location.pathname).startsWith(
                  "/taskDrilldownData"
                ) === true && (
                  <Route
                    path="/taskDrilldownData"
                    component={DrilldownDataRoute}
                  />
                )}
                {String(props.history.location.pathname).startsWith(
                  "/callDrilldownData"
                ) === true && (
                  <Route
                    path="/callDrilldownData"
                    component={DrilldownDataRoute}
                  />
                )}
              </>
            )}
          </>
        )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userStatus: state.user.status,
    userRole: state.user.role,
    user: state.user.data,
    authToken: state.user.authToken,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    constants:state.constants.data,
    isUsingApp: state.user.isUsingApp,
    organization: state.organization,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
    initialParams:state.utils.initialParams,
    currentRoute:state.currentRoute.initialParams
  };
};

export default connect(mapStateToProps)(HomeRoute);